import styles from './LoyaltyBanner.css'
import * as mpCustomersList from 'mixpanel/customers/list'
import {Link} from 'react-router'

class LoyaltyBanner extends React.Component {
  render () {
    return (
      <div className={styles.container}>
        <Link to='/customers/loyalty' onClick={this._onBannerClick}>
          <img src={require('assets/images/loyalty-banner.png')} className={styles.banner} />
        </Link>
      </div>
    )
  }

  _onBannerClick = () => {
    mpCustomersList.loyaltyBannerClick()
  }
}

export default LoyaltyBanner



// WEBPACK FOOTER //
// ./app/pages/Customers/CustomerList/ListNonLoyalty/ActionBar/LoyaltyBanner/LoyaltyBanner.js